export default __webpack_public_path__ + "assets/e7a169fda806d16cb877f6bfba2af574.ttf";